import React, { useState } from 'react';
import { SensitiveGate } from './SensitiveGate';
import { Lock } from 'lucide-react';

/**
 * Inline (non-blocking) sensitive section: shows a locked card until the user
 * chooses to unlock, then runs the step-up SensitiveGate and reveals children.
 */
export const SensitiveSection = ({ children, title = 'Security Settings' }) => {
  const [unlocking, setUnlocking] = useState(false);
  const [unlocked, setUnlocked] = useState(false);

  if (unlocked) return children;

  return (
    <>
      <div className="bg-white rounded-2xl border border-slate-200 p-6 flex items-center justify-between gap-4 flex-wrap"
           data-testid="sensitive-section-locked">
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 rounded-xl bg-slate-100 flex items-center justify-center">
            <Lock className="w-5 h-5 text-slate-500" />
          </div>
          <div>
            <h3 className="font-semibold text-slate-900">{title}</h3>
            <p className="text-sm text-slate-500">For your security, please verify your identity before continuing.</p>
          </div>
        </div>
        <button onClick={() => setUnlocking(true)}
                className="h-10 px-5 rounded-full bg-cyan-500 text-white text-sm font-semibold hover:bg-cyan-600 transition-colors"
                data-testid="sensitive-section-unlock-btn">
          Verify & Unlock
        </button>
      </div>
      {unlocking && (
        <SensitiveGate title={title} onCancel={() => setUnlocking(false)} onVerified={() => setUnlocked(true)} />
      )}
    </>
  );
};

export default SensitiveSection;
